/**
 * Yatay kaydirma kablarinda dokunmatik tap'i kurtarir.
 *
 * Sorun: kartlar `overflow-x: auto` olan bir kabin icinde. Mobil tarayicilar
 * parmak birkac piksel kaydiginda hareketi kabin pan'i sayiyor ve tap'i hic
 * `click` olayina cevirmiyor. Kullanici karta basiyor, slider biraz kayiyor,
 * link acilmiyor. Masaustunde fare bu toleransa girmedigi icin sorun yalnizca
 * mobilde goruluyordu.
 *
 * Cozum: dokunmayi kendimiz olcuyoruz. Parmak esikten az kaydiysa, basma kisa
 * surduyse ve kap gercekten kaymadiysa bu bir tap'tir; tarayici `click`
 * uretmezse linki kendimiz aciyoruz. Tarayici uretirse `click` dinleyicisi
 * yedegi iptal eder, boylece iki kez gezinme olmaz.
 */
(function () {
  var TAP_SLOP = 10; // parmagin izin verilen kaymasi (px)
  var TAP_TIME = 600; // bundan uzun basma tap sayilmaz (ms)
  var CLICK_GRACE = 250; // tarayicinin click uretmesi icin beklenen sure (ms)
  var SCROLL_SLOP = 2; // kap bu kadardan fazla kaydiysa pan'di (px)

  function attach(track, linkSelector) {
    if (!track || track.dataset.nourSliderTap === 'on') return;
    track.dataset.nourSliderTap = 'on';

    var began = null;
    var fallback = null;

    function clearFallback() {
      if (fallback) {
        clearTimeout(fallback);
        fallback = null;
      }
    }

    track.addEventListener(
      'touchstart',
      function (e) {
        clearFallback();

        if (e.touches.length !== 1) {
          began = null;
          return;
        }

        var touch = e.touches[0];
        began = {
          x: touch.clientX,
          y: touch.clientY,
          at: Date.now(),
          scroll: track.scrollLeft
        };
      },
      { passive: true }
    );

    track.addEventListener(
      'touchcancel',
      function () {
        began = null;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchend',
      function (e) {
        var start = began;
        began = null;

        if (!start || e.changedTouches.length !== 1) return;

        var touch = e.changedTouches[0];
        if (Math.abs(touch.clientX - start.x) > TAP_SLOP) return;
        if (Math.abs(touch.clientY - start.y) > TAP_SLOP) return;
        if (Date.now() - start.at > TAP_TIME) return;
        if (Math.abs(track.scrollLeft - start.scroll) > SCROLL_SLOP) return;

        var link = e.target && e.target.closest ? e.target.closest(linkSelector) : null;
        if (!link || !link.href) return;

        fallback = setTimeout(function () {
          fallback = null;
          window.location.href = link.href;
        }, CLICK_GRACE);
      },
      { passive: true }
    );

    // Tarayici tap'i click'e cevirdiyse yedek gezinmeye gerek yok.
    track.addEventListener('click', clearFallback, true);
  }

  window.NourSliderTap = { attach: attach };
})();
